import {Badge} from "react-bootstrap";
import React from "react";
import TooltipImage from "../../../components/tooltip/TooltipImage";

function Title(props) {
    return <div className="d-flex flex-wrap align-items-center w-100 gap-row-2">
        {!props.tooltipImage &&
            <span className={"float-left mr-2 " + props.className}>{props.name}</span>}
        {props.tooltipImage &&
            <TooltipImage className={"float-left mr-2 " + props.className}
                          fileName={props.tooltipImage.fileName}
                          filePath={props.tooltipImage.filePath}>{props.name}</TooltipImage>}
        {props.label && !props.labels &&
            <Badge className={"float-right badge-primary-outline ml-4"}>{props.label}</Badge>}
        {props.labels && props.labels}
    </div>;
}

export default Title;
